import { motion } from "framer-motion";
import { Mic, Square } from "lucide-react";

const ChatInput = ({
  inputMessage, setInputMessage, sendMessage, showBreakState, inputDisabled,
  isRecording, isTranscribing, startRecording, stopRecording,
  showStickers, setShowStickers, sendSticker, stickerCategory, setStickerCategory,
  STICKER_CATEGORIES
}) => {
  const micBg = (() => {
    if (isRecording) return '#E74C3C';
    if (isTranscribing) return '#D8CCE8';
    if (inputDisabled) return '#E8E0F0';
    return '#F0E8F8';
  })();

  return (
    <div className="p-3 border-t" style={{ borderColor: '#E8E0F0', backgroundColor: '#FDFBF8' }}>
      <div className="flex gap-1.5 items-center">
        {/* Mic button */}
        <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
          onClick={isRecording ? stopRecording : startRecording}
          disabled={inputDisabled && !isRecording}
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 transition-colors"
          style={{ backgroundColor: micBg }}
          data-testid="mic-button"
          title={isRecording ? 'Stop recording' : 'Speak to Papaya'}>
          {isRecording
            ? <Square size={14} style={{ color: '#FFFFFF' }} fill="#FFFFFF" />
            : <Mic size={16} style={{ color: inputDisabled ? '#B0A5C0' : '#4F378B' }} />}
        </motion.button>

        {/* Text input */}
        <textarea value={inputMessage} onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
          placeholder={isTranscribing ? "Transcribing..." : showBreakState ? "Return from your break first..." : "Speak to Papaya..."}
          disabled={inputDisabled}
          rows={2}
          className="flex-1 px-3 py-2 rounded-2xl border-2 outline-none text-sm transition-colors disabled:opacity-50 resize-none"
          style={{ fontFamily: "'Nunito', sans-serif", borderColor: '#E8E0F0', backgroundColor: '#FFFFFF', color: '#3D3352', minHeight: '44px', maxHeight: '100px' }}
          onFocus={(e) => e.target.style.borderColor = '#7B5EA7'}
          onBlur={(e) => e.target.style.borderColor = '#E8E0F0'}
          data-testid="chat-input" />

        {/* Sticker toggle */}
        <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
          onClick={() => setShowStickers(!showStickers)}
          className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: showStickers ? '#F0E8F8' : 'transparent' }}
          data-testid="sticker-toggle">
          <span className="text-lg">&#x1F600;</span>
        </motion.button>

        {/* Send button */}
        <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
          onClick={sendMessage}
          disabled={inputDisabled || !inputMessage.trim()}
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-white"
          style={{
            background: inputDisabled || !inputMessage.trim() ? '#D8CCE8' : 'linear-gradient(135deg, #4F378B 0%, #7B5EA7 100%)',
          }}
          data-testid="send-message">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
          </svg>
        </motion.button>
      </div>
    </div>
  );
};

export default ChatInput;
